<template>
  <StdPageContainer type="create">
    <template slot="title">
      <StdPageTitle :title="$t('lang.k_395001')">
        <div slot="content">{{ $t('lang.k_395002') }}</div>
      </StdPageTitle>
    </template>
    <template slot="content">
      <vh-form
        class="sign-form-wrap"
        :rules="rules"
        :model="form"
        ref="form"
        inline
        label-width="102px"
      >
        <vh-form-item :label="$t('lang.k_395003')" v-if="form.pushType == 1" prop="pushTime">
          <vh-date-picker
            :append-to-body="false"
            class="inline_input"
            v-model="form.pushTime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            :pickerOptions="pickerOptions"
            size="small"
            type="datetime"
            :placeholder="$t('lang.k_395004')"
            round
          ></vh-date-picker>
          {{ $t('lang.k_395005') }}
          <p v-if="form.pushType == 1" class="time_tips">{{ $t('lang.k_395006') }}</p>
        </vh-form-item>
        <vh-form-item :label="$t('lang.k_395007')">
          <vh-autocomplete
            popper-class="sign-tips-autocomplete"
            class="form-input"
            :maxlength="15"
            show-word-limit
            ref="custom_title"
            :fetch-suggestions="querySearch('custom_title')"
            v-model="form.signTip"
          >
            <template slot-scope="{ item }">
              <div v-if="item.id == -2" @click.stop="editCustom('1')" class="name" :key="item.id">
                {{ querySearchRes.custom_title.length > 11 ? '' : item.content }}
              </div>
              <div v-else-if="item.id >= 0" class="name" :key="item.id">
                {{ item.content }}
                <div class="tips-ctr">
                  <vh-button type="text" @click.stop="editCustom('1', item)">
                    {{ $t('lang.k_395008') }}
                  </vh-button>
                  <vh-button type="text" @click.stop="delCustomTips(item.id)">
                    {{ $t('lang.k_395009') }}
                  </vh-button>
                </div>
              </div>
              <div v-else class="name" :key="item.id">{{ item.content }}</div>
            </template>
          </vh-autocomplete>
        </vh-form-item>
        <vh-form-item :label="$t('lang.k_395010')">
          <vh-select class="form-input" v-model="form.duration" popper-class="sign-select">
            <vh-option
              v-for="(opt, idx) in durationOps"
              :key="idx"
              :label="opt.label"
              :value="opt.value"
              class="sign-form-wrap-select"
            ></vh-option>
          </vh-select>
        </vh-form-item>
        <vh-form-item label=" " v-show="form.duration == -1" prop="custom">
          <vh-input
            class="form-input"
            :placeholder="$t('lang.k_395011')"
            style="width: auto"
            v-model="form.custom"
            :maxlength="4"
          ></vh-input>
          {{ $t('lang.k_395012') }}
        </vh-form-item>
        <vh-form-item :label="$t('lang.k_395013')">
          <vh-autocomplete
            class="form-input"
            popper-class="sign-tips-autocomplete"
            :maxlength="15"
            show-word-limit
            ref="custom_success_tips"
            :fetch-suggestions="querySearch('custom_success_tips')"
            v-model="form.signInsuccessTips"
          >
            <template slot-scope="{ item }">
              <div v-if="item.id == -2" @click.stop="editCustom('2')" class="name" :key="item.id">
                {{ querySearchRes.custom_success_tips.length > 11 ? '' : item.content }}
              </div>
              <div v-else-if="item.id >= 0" class="name" :key="item.id">
                {{ item.content }}
                <div class="tips-ctr">
                  <vh-button type="text" @click.stop="editCustom('2', item)">
                    {{ $t('lang.k_395008') }}
                  </vh-button>
                  <vh-button type="text" @click.stop="delCustomTips(item.id)">
                    {{ $t('lang.k_395009') }}
                  </vh-button>
                </div>
              </div>
              <div v-else class="name" :key="item.id">{{ item.content }}</div>
            </template>
          </vh-autocomplete>
        </vh-form-item>

        <vh-form-item :label="$t('lang.k_395014')">
          <vh-switch
            v-model="form.sound_status"
            active-color="#FB3A32"
            :active-value="1"
            :inactive-value="0"
          ></vh-switch>
          <span style="overflow-wrap: break-word; word-break: normal">
            {{ !!form.sound_status ? $t('lang.k_395015') : $t('lang.k_395016') }}
          </span>
          <div class="trial-sound">
            <vh-button type="text" @click="handleTrialSound">{{ $t('lang.k_395017') }}</vh-button>
            <vh-tooltip placement="right">
              <div class="sign-form-wrap-tip" slot="content" style="background: #333">
                <div>{{ $t('lang.k_395018') }}</div>
                <div>{{ $t('lang.k_395019') }}</div>
              </div>
              <i class="vh-iconfont vh-line-question" style="margin-left: 4px"></i>
            </vh-tooltip>
            <TrialSound ref="audioTrialSound" />
          </div>
        </vh-form-item>

        <vh-form-item :label="$t('lang.k_395020')">
          <vh-switch
            class="kick-switch"
            v-model="form.auto_kick_unsigned"
            active-color="#FB3A32"
            :active-value="1"
            :inactive-value="0"
            :active-text="
              (!!form.auto_kick_unsigned ? $t('lang.k_395021') : $t('lang.k_395022')) +
              $t('lang.k_395023')
            "
          ></vh-switch>
        </vh-form-item>
        <vh-form-item :label="$t('lang.k_395024')">
          <vh-switch
            @change="autoSignChange"
            v-model="form.autoSign"
            active-color="#FB3A32"
            :active-text="!!form.autoSign ? $t('lang.k_395025') : $t('lang.k_395026')"
          ></vh-switch>
          <!-- <vh-tooltip placement="right">
      <div class="sign-form-wrap-tip" slot="content" style="background: #333">
        <div>1.默认关闭；</div>
        <div>2.开启自动签到后，观众将在设置的时间收到签到提示；</div>
        <div>3.活动结束或回放时，观看者收不到签到提示。</div>
      </div>
      <i class="vh-iconfont vh-line-question" style="vertical-align: middle"></i>
    </vh-tooltip> -->
        </vh-form-item>
        <vh-form-item
          :label="$t('lang.k_395027')"
          v-show="form.autoSign"
          class="formm-item--interval"
        >
          <vh-select class="form-input" v-model="form.intervalValue" popper-class="sign-select">
            <vh-option
              v-for="(opt, idx) in intervalOps"
              :key="idx"
              :label="opt.label"
              :value="opt.value"
              class="select-option"
            ></vh-option>
          </vh-select>
          <vh-tooltip placement="right" class="form-input-tip">
            <div class="sign-form-wrap-tip" slot="content" style="background: #333">
              <div>{{ $t('lang.k_395028') }}</div>
            </div>
            <i class="vh-iconfont vh-line-question" style="padding-left: 6px"></i>
          </vh-tooltip>
        </vh-form-item>
        <vh-form-item
          label=" "
          v-if="form.intervalValue == -1 && form.autoSign"
          prop="intervalCustom"
          class="formm-item--interval"
        >
          <vh-input
            class="form-input"
            v-model="form.intervalCustom"
            :placeholder="$t('lang.k_395029')"
            style="width: auto; width: 200px"
          >
            <template slot="append">{{ $t('lang.k_395030') }}</template>
          </vh-input>
        </vh-form-item>
        <div class="sign-form-wrap-start">
          <vh-button type="primary" size="" round class="sign-form-wrap-start-btn" @click="submit">
            {{ $t('lang.k_395031') }}
          </vh-button>
        </div>
        <vh-dialog
          :visible.sync="showEditTips"
          width="400px"
          class="sign_tips"
          append-to-body
          :title="$t('lang.k_395032')"
          top="25vh"
        >
          <div>
            <vh-input
              :rows="4"
              ref="tipsInput"
              :placeholder="$t('lang.k_395033')"
              v-model="curEditTips.content"
              maxlength="15"
              show-word-limit
            ></vh-input>
          </div>
          <span slot="footer">
            <vh-button
              type="primary"
              @click="saveCustomTips"
              :disabled="!curEditTips.content"
              size="medium"
              round
            >
              {{ $t('lang.k_395034') }}
            </vh-button>
            <vh-button type="default" @click="showEditTips = false" size="medium" round>
              {{ $t('lang.k_395035') }}
            </vh-button>
          </span>
        </vh-dialog>
        <div class="cancel-signin-dialog" v-if="!!curSignIn">
          <vh-dialog
            :visible="!!curSignIn"
            width="400px"
            class=""
            :title="$t('lang.k_395001')"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :modal-append-to-body="false"
            top="25vh"
          >
            <div class="cancel-signin-content">
              {{ $t('lang.k_395036', [curSignIn?.push_time]) }}
              <p class="warn-tip">{{ $t('lang.k_395063') }}</p>
            </div>
            <span slot="footer">
              <vh-button type="primary" @click="handleCancelSignIn" size="medium" round>
                {{ $t('lang.k_395037') }}
              </vh-button>
            </span>
          </vh-dialog>
        </div>
      </vh-form>
      <router-link
        :to="{
          path: '/live/interactionDetail',
          query: {
            roomId: this.$route.query.roomId,
            id: this.$route.params.str,
            title: $t('lang.k_395001'),
            mkey: 'sign_in',
            wType: this.$route.query.type
          }
        }"
        class="link data_link"
      >
        {{ $t('lang.k_395038') }}
      </router-link>
    </template>
  </StdPageContainer>
</template>

<script>
  import regRule from '@/utils/reg-rule.js';
  import { throttle } from 'lodash';
  import { StdPageContainer, StdPageTitle } from '@vhcl/ui-console';
  import TrialSound from './components/trial-sound/index.vue';
  export default {
    name: 'SigninSet',
    components: { TrialSound, StdPageContainer },
    data() {
      const tipText = this.$t('lang.k_395039');
      const resTipText = this.$t('lang.k_395040');
      return {
        defaultText: tipText,
        defaultResTipText: resTipText,
        form: {
          pushType: 1, // 签到推送方式，0：手动，1：定时
          signTip: tipText, // 签到提示语
          duration: 30, // 签到显示的时间，单位秒，
          signInsuccessTips: resTipText, // 签到成功提示语,
          autoSign: false, // 是否自动发起签到，1自动，0取消自动
          intervalValue: 5, // 自动发起签到的轮询定时时间，单位秒
          intervalCustom: 5,
          custom: 90,
          sound_status: 0, // 提示音效开关
          auto_kick_unsigned: 0, //未签到踢出直播间，1开启，0关闭
          pushTime: '' //定时推送时间
        },
        durationOps: [
          {
            value: 10,
            label: this.$t('lang.k_395041')
          },
          {
            value: 30,
            label: this.$t('lang.k_395042')
          },
          {
            value: 60,
            label: this.$t('lang.k_395043')
          },
          {
            value: 120,
            label: this.$t('lang.k_395044')
          },
          {
            value: 180,
            label: this.$t('lang.k_395045')
          },
          {
            value: -1,
            label: this.$t('lang.k_395046')
          }
        ],

        intervalOps: [
          // {
          //   value: 60,
          //   label: '1分钟'
          // },
          {
            value: 5,
            label: this.$t('lang.k_395047')
          },
          {
            value: 15,
            label: this.$t('lang.k_395048')
          },
          {
            value: 30,
            label: this.$t('lang.k_395049')
          },
          {
            value: -1,
            label: this.$t('lang.k_395046')
          }
        ],

        showEditTips: false, //提示语编辑弹框
        curSignIn: null, //取消签到弹框
        curEditTips: {
          id: undefined,
          content: ''
        },
        querySearchRes: {},
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      };
    },
    computed: {
      isLiving() {
        return true;
      }
    },
    created() {
      this.rules = {
        pushTime: {
          validator: (rule, value, callback) => {
            if (this.form.pushType == 1 && !value) {
              callback(new Error(this.$t('lang.k_395050')));
            } else {
              callback();
            }
          },
          trigger: 'change'
        },
        custom: {
          validator: (rule, value, callback) => {
            console.log(
              this.form.duration == -1 &&
                regRule.positiveInt0.test(value) &&
                value >= 10 &&
                value <= 9999
            );
            if (
              !(
                this.form.duration != -1 ||
                (this.form.duration == -1 &&
                  regRule.positiveInt0.test(value) &&
                  value >= 10 &&
                  value <= 9999)
              )
            ) {
              callback(new Error(this.$t('lang.k_395051')));
            } else if (
              this.form.autoSign &&
              ((this.form.duration != -1 && this.form.duration >= this.form.interval) ||
                (this.form.duration == -1 && this.form.custom >= this.form.interval))
            ) {
              callback(new Error(this.$t('lang.k_395052')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        },
        intervalCustom: {
          validator: (rule, value, callback) => {
            // 使用正则验证5-120的整数
            const regex = /^(5|6|7|8|9|10|[1-9]\d|1[0-1]\d|120)$/;
            if (!regex.test(value)) {
              return callback(new Error(this.$t('lang.k_395053')));
            }
            callback();
          },
          trigger: 'blur'
        }
      };
    },
    mounted() {
      this.getSignInfo();
    },
    methods: {
      getSignInfo() {
        this.$fetch('getSignDetail', { room_id: this.$route.query.roomId }).then(res => {
          if (res.data.push_type == 1 && res.data.push_status == 0) {
            this.curSignIn = res.data;
          }
        });
      },

      querySearch(type) {
        return (queryString, cb) => {
          cb('');
          this.$fetch('getSignCustomTips').then(res => {
            if (res.code == 200) {
              res.data.custom_title.unshift({
                id: -1,
                content: this.defaultText
              });

              res.data.custom_title.push({
                id: -2,
                content: this.$t('lang.k_395054')
              });
              res.data.custom_success_tips.unshift({
                id: -1,
                content: this.defaultResTipText
              });

              res.data.custom_success_tips.push({
                id: -2,
                content: this.$t('lang.k_395054')
              });
              this.querySearchRes = res.data;
              cb(
                res.data[type].map(item => {
                  item.value = item.content;
                  return item;
                })
              );
            }
          });
        };
      },
      autoSignChange(value) {
        console.warn('test----自动签到  改变值', value);
        // window.sessionStorage.setItem('isAutoSign', value)
      },
      // tipFocus(e) {
      //   if (e.target.value === this.defaultText) {
      //     this.form.signTip = '';
      //   }
      // },
      // tipBlur(e) {
      //   if (e.target.value === '') {
      //     this.form.signTip = this.defaultText;
      //   }
      // },
      submit: throttle(
        function () {
          this.$refs.form.validate(valid => {
            if (valid) {
              const data = Object.assign({}, this.form, {
                duration: this.form.duration != -1 ? this.form.duration : Number(this.form.custom),
                interval:
                  (this.form.intervalValue != -1
                    ? this.form.intervalValue
                    : Number(this.form.intervalCustom)) * 60
              });
              this.$fetch('startSignIn', {
                room_id: this.$route.query.roomId,
                sign_tips: data.signTip, // 签到提示语
                show_time: data.duration, // 签到显示的时间，单位秒，默认30
                is_auto_sign: Number(data.autoSign), // 是否自动发起签到，1自动，0取消自动，默认0
                auto_sign_time: data.interval, // 自动发起签到的轮询定时时间，单位秒
                auto_kick_unsigned: data.auto_kick_unsigned, // 是否自动踢出未签到用户，1是，0否，默认0
                sign_in_success_tips: data.signInsuccessTips,
                push_type: data.pushType,
                push_time: data.pushTime,
                sound_status: data.sound_status
              })
                .then(res => {
                  if (res.code == 200) {
                    this.curSignIn = res.data;
                  }
                })
                .catch(err => {
                  this.$vhMessage.error(err.msg);
                });
            }
          });
        },
        2000,
        { trailing: false }
      ),

      editCustom(type, item) {
        this.curEditTips = {
          id: item?.id,
          content: item?.content,
          type
        };
        this.showEditTips = true;
        this.$nextTick(() => {
          this.$refs.custom_success_tips.activated = false;
          this.$refs.custom_title.activated = false;
        });
      },
      async saveCustomTips() {
        if (
          (this.curEditTips.type == 1 && this.curEditTips.content == this.$t('lang.k_395039')) ||
          (this.curEditTips.type == 1 && this.curEditTips.content == this.$t('lang.k_395040'))
        ) {
          this.$vhMessage.error(this.$t('lang.k_395055'));
          return;
        }

        const res = await (!this.curEditTips.id
          ? this.$fetch('createSignCustomTips', this.curEditTips)
          : this.$fetch('editSignCustomTips', this.curEditTips)
        ).finally(data => data);
        if (res.code == 200) {
          this.showEditTips = false;
          this.curEditTips.type == 1
            ? (this.form.signTip = this.curEditTips.content)
            : (this.form.signInsuccessTips = this.curEditTips.content);
          this.$vhMessage.success(this.$t('lang.k_395056'));
        } else {
          this.$vhMessage.error(res.msg);
        }
      },
      async delCustomTips(id) {
        const res = await this.$fetch('delSignCustomTips', { id }).finally(data => data);
        if (res.code == 200) {
          this.$vhMessage.success(this.$t('lang.k_395057'));
          this.$refs.custom_title.$data.suggestions =
            this.$refs.custom_title.$data.suggestions.filter(el => el.id !== id);
          this.$refs.custom_success_tips.$data.suggestions =
            this.$refs.custom_success_tips.$data.suggestions.filter(el => el.id !== id);
          this.querySearchRes.custom_title = this.querySearchRes.custom_title.filter(
            el => el.id !== id
          );
          this.querySearchRes.custom_success_tips = this.querySearchRes.custom_success_tips.filter(
            el => el.id !== id
          );
        } else {
          this.$vhMessage.error(res.msg);
        }
      },
      // 试听
      handleTrialSound() {
        this.$refs['audioTrialSound']?.play();
      },
      handleCancelSignIn() {
        this.$vhConfirm(this.$t('lang.k_395058'), this.$t('lang.k_395059'), {
          confirmButtonText: this.$t('lang.k_395060'),
          cancelButtonText: this.$t('lang.k_395061'),
          roundButton: true
        })
          .then(() => {
            this.$fetch('delSignIn', {
              room_id: this.$route.query.roomId,
              sign_ids: this.curSignIn.id
            }).then(res => {
              if (res.code == 200) {
                this.$vhMessage.success(this.$t('lang.k_395062'));
                this.curSignIn = null;
              }
            });
          })
          .catch(() => {
            const data = this.curSignIn;
            this.curSignIn = null;
            this.$nextTick(() => {
              this.curSignIn = data;
            });
          });
      }
    }
  };
</script>
<style lang="less" scoped>
  .tips-ctr {
    float: right;
  }
  .inline_input {
    width: 176px;
    vertical-align: middle;
  }
  .tips {
    line-height: 20px;
    font-size: 12px;
    color: #262626;
  }
  .time_tips {
    font-size: 13px;
    line-height: 20px;
    color: #fb2626;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
  }
  .cancel-signin-dialog {
    /deep/ .vh-dialog__wrapper {
      position: absolute;
    }
    /deep/ .v-modal {
      position: absolute;
    }

    .cancel-signin-content {
      line-height: 1.6;

      .warn-tip {
        color: #fb2626;
        margin-top: 20px;
        white-space: normal;
        word-break: break-word;
        overflow-wrap: break-word;
      }
    }
  }
  .data_link {
    position: absolute;
    right: 30px;
    top: 50px;
  }
</style>
<style lang="less">
  .sign-form-wrap {
    width: 660px;
    padding-bottom: 32px;
    .vh-form-item {
      margin-right: 0;
      width: 100%;
      .vh-form-item__content {
        width: calc(100% - 102px);
        .form-input {
          width: 100%;
          &-tip {
            position: absolute;
            left: 100%;
          }
        }
      }
    }
    .vh-form-item.formm-item--interval {
      .vh-form-item__content {
        width: calc(100% - 96px);
      }
    }
    .vh-switch {
      margin-right: 5px;
      height: 16px;
      line-height: 16px;
      &__core {
        width: 28px !important;
        height: 16px;
        flex-shrink: 0;
      }
      &__core:after {
        width: 12px;
        height: 12px;
      }
      .vh-switch__label--right * {
        line-height: 20px;
      }

      &.kick-switch {
        .vh-switch__label span {
          color: #fb2626;
        }
      }
    }

    .trial-sound {
      display: inline-block;
      vertical-align: middle;
    }

    .vh-switch.is-checked .vh-switch__core::after {
      margin-left: -13px;
    }
    &-select {
      line-height: 40px !important;
      &:hover {
        background-color: #f7f7f7;
      }
      &.hover {
        font-weight: normal;
        background: none;
      }
      &:hover {
        background-color: #f7f7f7;
      }
      &.selected {
        background-color: #f7f7f7;
        font-weight: normal;
        color: #606266;
      }
    }
    &-tip {
      line-height: 18px;
      font-size: 12px;
      width: 238px;
      font-weight: 400;
      color: #ffffff;
      line-height: 18px;
    }
    &-start {
      text-align: center;
      &-btn {
        width: 120px;
      }
    }
    .vh-iconfont {
      color: #999;
      font-size: 14px;
    }
    .vh-form-item.is-success {
      .vh-input__inner {
        border-color: #e2e2e2;
      }
    }
  }
  .sign-tips-autocomplete {
    li {
      padding: 0;
      & > div {
        padding: 0 10px;
      }
    }
  }
</style>
